/**
 * v-data-table headers for the per-publication delivery report
 * (`GET api/Management/Releases/publications/{pid}/deliveries`).
 *
 * Sorting is disabled across the board: the endpoint is paged server-side and takes no
 * sort parameters, so an enabled sort arrow would silently reorder only the current page.
 * Mirrors the shape of `src/features/Company/config/company.headers.js`.
 */
export default [
  {
    text: 'Recipient',
    value: 'email',
    width: '260px',
    align: 'left',
    sortable: false,
    order: 0,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Company',
    value: 'companyName',
    width: '200px',
    align: 'left',
    sortable: false,
    order: 1,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Status',
    value: 'status',
    width: '140px',
    align: 'left',
    sortable: false,
    order: 2,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Sent',
    value: 'sentAt',
    width: '160px',
    align: 'left',
    sortable: false,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Reason',
    value: 'reason',
    align: 'left',
    sortable: false,
    order: 4,
    hidable: true,
    hidden: false,
  },
];
